export default __webpack_public_path__ + "static/media/Parallax-HUD-Targeting (Selector Ring).9d2f7fab.jpg";